import React from 'react'
import IconButton from '@mui/material/IconButton';
import {
  WorkHistoryOutlined,
} from "@mui/icons-material";

import CustomMenu from '../../../../../components/Menu';
import CustomMenuItem from '../../../../../components/Menu/CustomMenuItem';
import CustomModalDialog from '../../../../../components/Dialog/FormDialog';
import AddWorklog from '../../worklog/addWorklog/addWorklogDialog';
import MobileAssignParentCard from './mobile/MobileAssignParentCard';

import mobileDots from "../../../../../styles/svg/mobileDots.svg";
import ParentAssignIcon from "../../../../../styles/svg/parent-assign-edit.svg";
import { useMobileCardMenuState } from './hooks/useMobileCardMenuState';


  function MobileCardMenu({ buttonStyles, cardId, card }) {
    const {
      anchorEl,
      cardData,
      fullScreen,
      handleAddWorklog,
      handleAssignParent,
      handleClick,
      handleClose,
      openAddWorklog,
      openAssignParent,
      setOpenAddWorklog,
      setOpenAssignParent,
    } = useMobileCardMenuState(card);

    return (
      <>
        <IconButton
          aria-label="close"
          onClick={handleClick}
          sx={{
            ...buttonStyles,
            top: 10,
          }}
          className='mr-1'
        >
          <img src={mobileDots} alt="menu" />
        </IconButton>

        <CustomMenu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          className="mobile-card-details-menu"
        >
          <CustomMenuItem
            onClick={handleAddWorklog}
            className="mobile-card-details-menu-item"
          >
            <WorkHistoryOutlined className="icon" />
            Add Worklog
          </CustomMenuItem>
          <CustomMenuItem
            onClick={handleAssignParent}
            className="mobile-card-details-menu-item"
          >
            <img src={ParentAssignIcon} alt="parent-assign" className="icon" />
            {cardData?.parent_card_id ? "Change Parent" : "Assign Parent"}
          </CustomMenuItem>
        </CustomMenu>

        <CustomModalDialog
          open={openAssignParent}
          handleClose={() => setOpenAssignParent(false)}
          title={"Assign Parent"}
          fullScreen={fullScreen}
        >
          <MobileAssignParentCard
            onClose={() => setOpenAssignParent(false)}
            card={cardData}
            cardId={cardId}
          />
        </CustomModalDialog>

        {openAddWorklog && (
          <AddWorklog
            cardId={cardId}
            addWorklog={openAddWorklog}
            setAddWorklog={() => setOpenAddWorklog(false)}
            heading={"Add Work Log"}
            buttonName={"Save"}
          />
        )}
      </>
    );
  }
 

export default MobileCardMenu;
